// @ts-nocheck
import { deleteStoreListApi } from "@store/Services/StoreListService";
import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    storeListId: string;
    onSuccess?: () => void;
}>;

export const RequestRemoveStorelist: HandlerType = props => {
    return deleteStoreListApi({ storeListId: props.parameter.storeListId });
};

export const ResetStoreListsData: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreLists/Reset",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [RequestRemoveStorelist, ResetStoreListsData, ExecuteOnSuccessCallback];

const deleteStoreList = createHandlerChainRunner(chain, "DeleteStoreList");
export default deleteStoreList;
